import {
  MRP_LOCATION_PUBLIC_LOCATION_ID,
  mrpLocationChipStyles,
  mrpLocationLabelForCode,
  type MrpLocation,
} from "@/lib/mrp";
import { cn } from "@/lib/utils";

/** Short chip label (SGS, Suntronic, Kodiak) when the id maps to an MRP site; otherwise abbreviation or full name. */
export function manufacturingLocationShortLabel(
  locationId: number | null | undefined,
  fallbackLabel?: string | null,
): string {
  if (locationId != null && locationId > 0) {
    const siteCode = mrpLocationFromPublicLocationId(locationId);
    if (siteCode != null) {
      return mrpLocationLabelForCode(siteCode);
    }
  }
  const trimmed = (fallbackLabel ?? "").trim();
  return trimmed !== "" ? trimmed : "—";
}

export function mrpLocationFromPublicLocationId(locationId: number): MrpLocation | null {
  for (const entry of Object.entries(MRP_LOCATION_PUBLIC_LOCATION_ID) as [MrpLocation, number][]) {
    if (entry[1] === locationId) {
      return entry[0];
    }
  }
  return null;
}

export function ManufacturingLocationChip({
  locationId,
  fallbackLabel,
  size = "md",
}: {
  locationId: number;
  fallbackLabel?: string;
  size?: "md" | "lg";
}): JSX.Element {
  const siteCode = mrpLocationFromPublicLocationId(locationId);
  if (siteCode != null) {
    const { label, className } = mrpLocationChipStyles(siteCode);
    return (
      <span
        className={cn(
          "inline-flex shrink-0 items-center rounded-md border font-semibold",
          size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs",
          className,
        )}
      >
        {label}
      </span>
    );
  }
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-md border border-slate-300 bg-slate-100 font-semibold text-slate-800",
        size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs",
      )}
    >
      {fallbackLabel != null && fallbackLabel.trim() !== "" ? fallbackLabel.trim() : `Location ${String(locationId)}`}
    </span>
  );
}
